module.exports = __webpack_public_path__ + "static/kapsulki_kawa_mleko-b9cc14af1be7eaf0149a4738d88fdb85.png";